module.exports = __webpack_public_path__ + "media/crypto/aave-f7b57474.png";